var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangularruler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_715_14746)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20349 2.80221C4.69196 1.289 2.10547 2.35949 2.10547 4.49832V27.9065C2.10547 29.0111 3.00092 29.9065 4.10547 29.9065H27.4879C29.6254 29.9065 30.6965 27.3227 29.1859 25.8104L6.20349 2.80221ZM7.90234 23.232V16.3189C7.90234 15.6492 8.71332 15.3153 9.18488 15.7908L16.041 22.7038C16.5104 23.1772 16.1752 23.982 15.5085 23.982H8.65234C8.23816 23.982 7.90234 23.6462 7.90234 23.232Z",
    fill: "url(#paint0_linear_715_14746)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1819 3.78107L5.24068 5.72231C5.03371 5.92928 4.69814 5.92928 4.49117 5.72231C4.28419 5.51534 4.28419 5.17976 4.49117 4.97279L6.43282 3.03113L7.1819 3.78107Z",
    fill: "#9D73E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8907 8.49518L9.99117 10.3947C9.78419 10.6017 9.78419 10.9372 9.99117 11.1442C10.1981 11.3512 10.5337 11.3512 10.7407 11.1442L12.6398 9.24511L11.8907 8.49518Z",
    fill: "#9D73E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3564 13.967L15.4912 15.8322C15.2842 16.0392 15.2842 16.3747 15.4912 16.5817C15.6981 16.7887 16.0337 16.7887 16.2407 16.5817L18.1055 14.7169L17.3564 13.967Z",
    fill: "#9D73E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8455 19.4623L20.9912 21.3166C20.7842 21.5236 20.7842 21.8591 20.9912 22.0661C21.1981 22.2731 21.5337 22.2731 21.7407 22.0661L23.5946 20.2122L22.8455 19.4623Z",
    fill: "#9D73E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2721 24.895L26.4287 26.7384C26.2217 26.9454 26.2217 27.281 26.4287 27.488C26.6356 27.6949 26.9712 27.6949 27.1782 27.488L29.0212 25.6449L28.2721 24.895Z",
    fill: "#9D73E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7563 22.9049C24.9633 22.6979 25.2988 22.6979 25.5058 22.9049C25.7128 23.1118 25.7128 23.4474 25.5058 23.6544L24.7563 24.4039C24.5493 24.6109 24.2138 24.6109 24.0068 24.4039C23.7998 24.197 23.7998 23.8614 24.0068 23.6544L24.7563 22.9049Z",
    fill: "#9D73E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3501 17.4205C19.557 17.2135 19.8926 17.2135 20.0996 17.4205C20.3065 17.6275 20.3065 17.963 20.0996 18.17L19.3501 18.9196C19.1431 19.1265 18.8075 19.1265 18.6005 18.9196C18.3936 18.7126 18.3936 18.377 18.6005 18.17L19.3501 17.4205Z",
    fill: "#9D73E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8813 11.9674C14.0883 11.7604 14.4238 11.7604 14.6308 11.9674C14.8378 12.1743 14.8378 12.5099 14.6308 12.7169L13.8813 13.4664C13.6743 13.6734 13.3388 13.6734 13.1318 13.4664C12.9248 13.2595 12.9248 12.9239 13.1318 12.7169L13.8813 11.9674Z",
    fill: "#9D73E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39693 6.51424C8.6039 6.30727 8.93947 6.30726 9.14644 6.51424C9.35341 6.72121 9.35341 7.05678 9.14644 7.26375L8.39693 8.0133C8.18996 8.22027 7.85439 8.22027 7.64742 8.0133C7.44044 7.80633 7.44044 7.47076 7.64742 7.26379L8.39693 6.51424Z",
    fill: "#9D73E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_715_14746",
    x: 1.80547,
    y: 1.79351,
    width: 28.3871,
    height: 28.413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.65098 0 0 0 0 0.678431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14746"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.529412 0 0 0 0 0.494118 0 0 0 0 0.615686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_14746",
    result: "effect2_innerShadow_715_14746"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.3,
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.913725 0 0 0 0 0.909804 0 0 0 0 0.92549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_14746",
    result: "effect3_innerShadow_715_14746"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_14746",
    x1: 18.8711,
    y1: 16.3726,
    x2: 8.12109,
    y2: 26.8101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B1BB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangularruler);
export default __webpack_public_path__ + "static/media/Triangular ruler.e988b15474de4c0d6aa3912f4cef09b7.svg";
export { ForwardRef as ReactComponent };